module.exports = __webpack_public_path__ + "img/coco-club-03.be673acb.jpg";